import { LinkButton } from '@/atoms/Button'
import { QuestionMarkFilled } from '@/atoms/Icons/QuestionMarkFilled'
import { ParagraphMD } from '@/atoms/Text'
import { paths } from '@/constants/paths'
import { Translate, useTranslate } from '@/utils/translate/translate-client'

interface HelpCastingButton {
  onClick?: () => void
}

export const HelpCastingButton: React.FC<HelpCastingButton> = ({ onClick }) => {
  const { t } = useTranslate('common')

  return (
    <LinkButton
      className="min-w-[190px] rounded"
      variant="plain"
      href={paths.blog.castToTv}
      onClick={onClick}
      prefetch={false}
      target="_blank"
    >
      <div className="mx-auto flex flex-row justify-center gap-2">
        <QuestionMarkFilled size={20} color1="white" color2="core-gray-800" className="m-auto" />
        <ParagraphMD className="md:hidden 2xl:block">
          <Translate t={t} i18nKey="helpCastingToTv">
            Help Casting to TV
          </Translate>
        </ParagraphMD>
        <ParagraphMD className="hidden md:block 2xl:hidden">
          <Translate t={t} i18nKey="helpCasting">
            Help Casting
          </Translate>
        </ParagraphMD>
      </div>
    </LinkButton>
  )
}
